<script lang="ts">
	import type { Device } from 'src/types/Device';
	import TrvPriorityView from 'src/components/Sidepanel/DeviceViews/Trv/TrvPriorityView.svelte';

	export let device: Device;
</script>

<TrvPriorityView {device} />
